/*
 * @Author: 贾晓红
 * @Date: 2019-09-17 14:07:28
 * @Last Modified by: 齐白宇
 * @Last Modified time: 2019-12-06 14:59:51
 */

import request from "@/request";
import { data } from "jquery";
const part_url = "recruit/web/recruit/";

/**
 * 查询招聘公告列表
 *
 * @param {*} pageNow 页数
 * @param {*} pageSize 每页数量
 * @param {*} category 招聘类型
 * @returns
 */
function getRecruitNoticeList(data) {
  let url = part_url + "noticeList";
  return request.get(url, data);
}

/**
 * 查询招聘详情
 *
 * @param {*} id 招聘公告id
 * @returns
 */
function getRecruitNoticeDetail(data) {
  let url = part_url + "getById";
  return request.get(url, data);
}

function getRecruitPosts(data) {
  let url = part_url + "postList";
  return request.get(url, data);
}

function getNoticeByPostName(data) {
  let url = part_url + "getNoticeByPostName";
  return request.get(url, data);
}

function getTeacherList() {
  let url = part_url + "getTeacherList";
  return request.get(url, {});
}

function getReNature() {
  let url = part_url + "getReNature";
  return request.get(url, {});
}

function getReExperience() {
  let url = part_url + "getReExperience";
  return request.get(url, {});
}

function getRecruitEducation() {
  let url = part_url + "getRecruitEducation";
  return request.get(url, {});
}

function getReScale() {
  let url = part_url + "getReScale";
  return request.get(url, {});
}

function getReFinancing() {
  let url = part_url + "getReFinancing";
  return request.get(url, {});
}

function getNoticeByMajorCategory() {
  let url = part_url + "getNoticeByMajorCategory";
  return request.get(url, {});
}

function getNoticeBySysPost() {
  let url = part_url + "getNoticeBySysPost";
  return request.get(url, {});
}

function getNoticeList() {
  let url = part_url + "getNoticeList";
  return request.get(url, {});
}
function getHotNoticeList() {
  let url = part_url + "getHostRecruit";
  return request.get(url, {});
}

function getSeacherButton(data) {
  let url = part_url + "getSeacherButton";
  return request.get(url, data);
}

export default {
  getRecruitNoticeList,
  getRecruitNoticeDetail,
  getRecruitPosts,
  getNoticeByPostName,
  getTeacherList,
  getReNature,
  getReExperience,
  getRecruitEducation,
  getReScale,
  getReFinancing,
  getNoticeByMajorCategory,
  getNoticeBySysPost,
  getNoticeList,
  getSeacherButton,
  getHotNoticeList
};



// WEBPACK FOOTER //
// ./src/api/recruitNotice.js